import { HTTPUnauthorized, HTTPForbidden, HTTPTimeoutError, resolveHttpErrorMessage } from './httpErrors';

export const errorDetails = ({
  message = 'None Specified',
  baseName = 'None',
  name = 'Unknown',
}) => ({ message, baseName, name });

const TYPED_HTTP_ERRORS = [HTTPUnauthorized, HTTPForbidden, HTTPTimeoutError];

function isTypedHttpError(err) {
  return TYPED_HTTP_ERRORS.some((Cls) => err instanceof Cls);
}

export class APIError extends Error {
  constructor(messageOrObject) {
    if (isTypedHttpError(messageOrObject)) {
      super(resolveHttpErrorMessage(messageOrObject));
      this.name = 'APIError';
      this.responseCode = messageOrObject.responseCode;
      this.baseError = messageOrObject;
      this.baseErrorName = messageOrObject.name;
      return;
    }

    if (messageOrObject?.responseBody && !messageOrObject?.name) {
      messageOrObject = messageOrObject.responseBody;
    }

    const resolvedMessage =
      typeof messageOrObject === 'object'
        ? resolveHttpErrorMessage({ responseBody: messageOrObject, message: messageOrObject?.message })
        : messageOrObject;

    super(resolvedMessage || 'Request failed');
    this.name = 'APIError';
    this.baseError =
      typeof messageOrObject === 'object' ? messageOrObject : undefined;
    this.baseErrorName =
      typeof messageOrObject === 'object' ? messageOrObject.name : undefined;
  }

  getAPIErrorDetails() {
    return errorDetails({
      message: this.message,
      baseName: this.baseErrorName,
      name: this.name,
    });
  }
}
